import React, { useState, useContext } from "react";
import { Field } from "formik";
import { setOldFileName, manageMapperStore } from "../../../contexts";
import { get, isEmpty } from "lodash";
import {
  FieldButtonGroup,
  FieldDropSide,
  FieldInput,
  SearchableList,
  UploadComponent,
} from "../../../components";
import { useDeepEffect } from "../../../abstracts";
const FileFormatData = [
  {
    label: "Excel",
    value: 3,
  },
  {
    label: "CSV",
    value: 1,
  },
  {
    label: "Fixed Length",
    value: 2,
  },
];

const yesNoOptions = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];
const SelectDataFromData = [
  {
    label: "First Sheet",
    value: 1,
  },
  {
    label: "Last Sheet",
    value: 2,
  },
  {
    label: "Sheet Number",
    value: 3,
  },
  {
    label: "Sheet Name",
    value: 4,
  },
];
const DCFormatoptions = [
  { value: 3, label: "DC - Payroll & Census" },
  { value: 2, label: "DC - Payroll" },
  { value: 1, label: "DC - Census" },
];

function FileInfo(props) {
  const {
    values,
    setFileUploadRequired,
    setFieldValue,
    fields,
    isEdit,
    editable,
    fileUploadRequired,
    state,
    isSubmitsucces,
    formName,
    previousFile,
    setPreviousFile,
    newFile,
    fileName,
    setNewFile,
    clearField,
    setClearField,
    setErrors,
  } = props;
  const { dispatch } = useContext(manageMapperStore);
  const [showFileName, setShowFileName] = useState(true);
  useDeepEffect(() => {
    if (!isEmpty(fileName) && !isEmpty(newFile)) {
      setShowFileName(false);
    }
  }, [newFile]);
  useDeepEffect(() => {
    setPreviousFile(
      values["fileName"]
        ? values["fileName"]
        : get(state, "api.data.fileName", [])
    );
  }, []);
  useDeepEffect(() => {
    if (isSubmitsucces === false) {
      setFieldValue("fileName", previousFile);
    }
  }, [isSubmitsucces]);
  const clearUploadFile = () => {
    if (
      clearField === false &&
      get(state, "api.fileuploadData.mappingConfiguration.fileName", null)
    ) {
      dispatch(
        setOldFileName({
          fileName: previousFile,
        })
      );
    }
  };
  const ExcelComponent = () => {
    return (
      <div>
        <Field
          name={fields.selectDataFrom}
          label={"Select Data From"}
          value={values[fields.selectDataFrom]}
          options={SelectDataFromData}
          isRequired
          direction={"bottom"}
          //disabled={editable}
          //disabled={isEdit || !isEmpty(get(state, formName, []))}
          popupContent={
            <SearchableList
              label={"Select Data From"}
              isNotTypeAhead
              options={SelectDataFromData}
              onSelect={(value) => setFieldValue(fields.selectDataFrom, value)}
              selectedValue={values[fields.selectDataFrom]}
            />
          }
          component={FieldDropSide}
        />

        {values[fields.selectDataFrom] == SelectDataFromData[2].value && (
          <Field
            name={fields.spreadSheetNumber}
            placeholder={SelectDataFromData[2].label}
            label={SelectDataFromData[2].label}
            noLabelTransform
            component={FieldInput}
            type="number"
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            value={values[fields.spreadSheetNumber]}
            isRequired
          />
        )}

        {values[fields.selectDataFrom] == SelectDataFromData[3].value && (
          <Field
            name={fields.spreadSheetName}
            placeholder={SelectDataFromData[3].label}
            label={SelectDataFromData[3].label}
            noLabelTransform
            component={FieldInput}
            // disabled={isEdit || !isEmpty(get(state, formName, []))}
            value={values[fields.spreadSheetName]}
            isRequired
          />
        )}
      </div>
    );
  };

  const CSVComponent = () => {
    return (
      <div>
        <div
          style={{ color: "#828282", fontSize: "12px" }}
          className="form-group mb-3"
        >
          <Field
            isRequired
            name={fields.delimiter}
            placeholder={"Delimiter"}
            label={"Delimiter"}
            value={values[fields.delimiter]}
            noLabelTransform
            component={FieldInput}
            validate={(value) => {
              return [undefined, null, ""].includes(value)
                ? "Required"
                : undefined;
            }}
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            //disabled={editable}
          />
        </div>
        <Field
          isRequired
          name={fields.hasHeader}
          label="Has Header"
          size="sm"
          options={yesNoOptions}
          //disabled={isEdit || !isEmpty(get(state, formName, []))}
          //disabled={editable}
          onChange={(value) => {
            setFieldValue(fields.hasHeader, value);
          }}
          selectedValue={values[fields.hasHeader]}
          component={FieldButtonGroup}
        />

        {!values[fields.hasHeader] && (
          <Field
            isRequired
            name={fields.checkForHeaderCountMismatch}
            label="Check for Header Count Mismatch"
            size="sm"
            options={yesNoOptions}
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            //disabled={editable}
            onChange={(value) => {
              setFieldValue(fields.checkForHeaderCountMismatch, value);
            }}
            selectedValue={values[fields.checkForHeaderCountMismatch]}
            component={FieldButtonGroup}
          />
        )}
        <br />
        <div className="form-group">
          <Field
            type="number"
            name={fields.contentStartsFrom}
            placeholder={"Content Starts From"}
            label={"Content Starts From (Row)"}
            noLabelTransform
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            //disabled={editable}
            value={values[fields.contentStartsFrom]}
            component={FieldInput}
            //validate={required}
            isRequired
          />
        </div>
      </div>
    );
  };

  const fixedLengthComponent = () => {
    return (
      <div style={{ fontSize: "12px" }} className="form-group mb-3">
        <Field
          name={fields.recordLength}
          label={"Record Length"}
          noLabelTransform
          component={FieldInput}
          type="number"
          //disabled={isEdit || !isEmpty(get(state, formName, []))}
          //disabled={editable}
          value={values[fields.recordLength]}
          // validate={(value) => (value ? null : "Required")}
          validate={(value) => {
            return [undefined, null, ""].includes(value)
              ? "Required"
              : undefined;
          }}
          isRequired
        />
      </div>
    );
  };

  const getExtensions = (x) => {
    let extensions;
    switch (x) {
      case 1:
        extensions = ".csv, .txt";
        break;
      case 2:
        extensions = " .txt, .yaml";
        break;
      case 3:
        extensions = ".xlsx, .xls";
        break;
    }
    return extensions;
  };

  return (
    <div>
      <Field
        name="uploadedFileType"
        label={"Target Data Model"}
        value={values["uploadedFileType"]}
        options={DCFormatoptions}
        isRequired
        //disabled={isEdit || editable}
        direction={"bottom"}
        popupContent={
          <SearchableList
            isNotTypeAhead
            options={DCFormatoptions}
            onSelect={(value) => {
              setFieldValue("uploadedFileType", value);
              setFileUploadRequired("");
              setErrors({});
            }}
            selectedValue={values["uploadedFileType"]}
          />
        }
        component={FieldDropSide}
        noLabelTransform
      />
      <div
        style={{ fontSize: "18px", marginBottom: "15px", fontWeight: "500" }}
      >
        File Information
      </div>

      <Field
        name={fields.fileFormat}
        label={"File format"}
        value={values[fields.fileFormat]}
        options={FileFormatData}
        isRequired
        direction={"bottom"}
        //disabled={isEdit || !isEmpty(get(state, formName, []))}
        //disabled={editable}
        popupContent={
          <SearchableList
            label={"File Format"}
            isNotTypeAhead
            options={FileFormatData}
            // onSelect={(value) => setFieldValue(fields.fileFormat, value)}
            onSelect={(value) => {
              setFieldValue(fields.fileFormat, value);
              setFieldValue(fields.contentStartsFrom, 1);
              setFieldValue(fields.delimiter, ",");
              setFieldValue(fields.recordLength, "");
              setFieldValue(fields.hasHeader, true);
              setFieldValue(fields.checkForHeaderCountMismatch, true);

              setFileUploadRequired("");
              setErrors({});
            }}
            selectedValue={values[fields.fileFormat]}
          />
        }
        component={FieldDropSide}
      />

      {(() => {
        if (values[fields.fileFormat] === 3) {
          return ExcelComponent();
        }
        if (values[fields.fileFormat] === 1) {
          return CSVComponent();
        }
        if (values[fields.fileFormat] === 2) {
          return fixedLengthComponent();
        }
      })()}

      {values[fields.fileFormat] == 3 && (
        <>
          {/* <div className="Load-def-source-selecttaglabel" >Has Header</div> */}
          <Field
            isRequired
            name={fields.hasHeader}
            label="Has Header"
            size="sm"
            options={yesNoOptions}
            //disabled={isEdit || !isEmpty(get(state, formName, []))}
            //disabled={editable}
            onChange={(value) => {
              setFieldValue(fields.hasHeader, value);
            }}
            selectedValue={values[fields.hasHeader]}
            component={FieldButtonGroup}
          />

          {!values[fields.hasHeader] && (
            <Field
              isRequired
              name={fields.checkForHeaderCountMismatch}
              label="Check for Header Count Mismatch"
              size="sm"
              options={yesNoOptions}
              //disabled={isEdit || !isEmpty(get(state, formName, []))}
              //disabled={editable}
              onChange={(value) => {
                setFieldValue(fields.checkForHeaderCountMismatch, value);
              }}
              selectedValue={values[fields.checkForHeaderCountMismatch]}
              component={FieldButtonGroup}
            />
          )}
          <br />
          <div className="form-group">
            <Field
              type="number"
              name={fields.contentStartsFrom}
              placeholder={"Content Starts From"}
              label={"Content Starts From (Row)"}
              noLabelTransform
              //disabled={isEdit || !isEmpty(get(state, formName, []))}
              //disabled={editable}
              value={values[fields.contentStartsFrom]}
              component={FieldInput}
              //validate={required}
              isRequired
            />
          </div>
        </>
      )}
      {/* {isEdit || !isEmpty(get(state, formName, [])) ? ( */}
      {editable ? (
        <>
          <div>Uploaded File</div>
          <div>
            <UploadComponent
              name={fields.uploadSourceFile}
              values={values}
              clearUploadFile={clearUploadFile}
              setFieldValue={setFieldValue}
              setNewFile={setNewFile}
              clearField={clearField}
              setShowFileName={setShowFileName}
              setFileUploadRequired={setFileUploadRequired}
              setClearField={setClearField}
              label="Upload Source File"
              fileExtensions={getExtensions(values[fields.fileFormat])}
            />
          </div>
          {showFileName ? (
            <div>
              {/* {!isEmpty(get(state, "api.data.fileName", []))
                ? get(state, "api.data.fileName", [])
                : values["fileName"]} */}
              {values["fileName"]
                ? values["fileName"]
                : get(state, "api.data.fileName", [])}
            </div>
          ) : null}
          <span style={{ color: "red" }}>{fileUploadRequired}</span>
        </>
      ) : (
        <div style={{ width: "40rem" }}>
          <div>
            <UploadComponent
              name={fields.uploadSourceFile}
              setFieldValue={setFieldValue}
              label="Upload Source File"
              fileExtensions={getExtensions(values[fields.fileFormat])}
            />
          </div>
          <div
            style={{
              fontSize: "0.75rem",
              marginTop: "0rem",
              color: "#ff5050",
            }}
          >
            <span style={{ color: "red" }}>{fileUploadRequired}</span>
          </div>
        </div>
      )}
    </div>
  );
}

export default FileInfo;
